import * as React from "react";

import { cn } from "@/lib/utils";

// A styled native select. The console's pick-one cases (exit IP pool) are
// short, flat lists where the platform control does everything needed —
// keyboard, mobile, screen readers — without a listbox dependency.
function Select({ className, ...props }: React.ComponentProps<"select">) {
  return (
    <select
      className={cn(
        "nb-select shadow-sm transition-colors [&>option]:bg-background",
        className,
      )}
      {...props}
    />
  );
}

export { Select };
